import { ActionList, ActionMenu } from "@primer/react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useCommonContext } from "../../contexts/common";
import { RootState } from "../../state/reducers";
export type ComboboxTruongProps = {
    isReadonly?: boolean,
    value?: number,
    onValueChanged: (id: number) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined"
}
const ComboboxTruong = (props: ComboboxTruongProps) => {
    const dm_truongs = useSelector((state: RootState) => state.auth.user_info?.campus);
    const { translate } = useCommonContext();
    const { language } = useSelector((x: RootState) => x.common)
    const selectedData = useMemo(() => {
        if (props.value && dm_truongs) {
            return dm_truongs.find(x => x.id == props.value)
        }
        return undefined
    }, [dm_truongs, props.value])
    return (
        <div style={{ width: '100%' }}>
        <ActionMenu>
            <ActionMenu.Button
                aria-label="Select school year"
                style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                {selectedData ? (language === "en" ? selectedData.ten_truong_en : selectedData.ten_truong) : translate("TruongCombobox.PlaceHolder")}
            </ActionMenu.Button>
            <ActionMenu.Overlay width="small">
                <ActionList selectionVariant="single">
                    {props.isShowClearButton &&
                        <ActionList.Item key={0} selected={props.value != undefined && 0 === props.value}
                            onSelect={() => {
                                props.onValueChanged(0)
                            }}
                        >
                            {language === "en" ? "Select" : "Chọn cấp học"}
                        </ActionList.Item>
                    }
                    {dm_truongs && dm_truongs.map((item, index) => {
                        return (
                            <ActionList.Item key={item.id} selected={props.value != undefined && item.id === props.value}
                                onSelect={() => {
                                    props.onValueChanged(item.id)
                                }}
                            >
                                {language === "en" ? item.ten_truong_en : item.ten_truong}
                            </ActionList.Item>
                        );
                    })}
                </ActionList>
            </ActionMenu.Overlay>
        </ActionMenu>
    </div>
    );
}

export { ComboboxTruong };

